import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M2.66699 12C2.66699 6.47716 7.14415 2 12.667 2C18.1899 2 22.667 6.47716 22.667 12C22.667 17.5229 18.1899 22 12.667 22C7.14415 22 2.66699 17.5229 2.66699 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4149 8.88269C15.8939 9.15755 16.0595 9.7687 15.7846 10.2477L13.491 14.245C12.6854 15.6487 10.6332 15.5644 9.94566 14.0993L9.51192 13.1748C9.27734 12.6748 9.49249 12.0793 9.99248 11.8447C10.4925 11.6102 11.088 11.8253 11.3225 12.3253L11.7562 13.2496L14.0499 9.25237C14.3247 8.77334 14.9359 8.60783 15.4149 8.88269Z"
      fill="#32323B"
    />
  </SvgIcon>
));
